import { useRef, useState } from "react";
import * as Icons from "react-icons/bs";
import { TDocumentRel, TWindowPosition, Themes } from "../../types";
import useDraggable from "../../hooks/useDraggable";
import '../../scss/lex-doc-rel.scss';
import { useDocuments } from "../../contexts/DekstopContext";

const DocumentRelsModal = ({
  theme,
  data,
  loading,
  onClose,
}: {
  theme: Themes,
  data: TDocumentRel[],
  loading: boolean,
  onClose: () => void,
}) => {
  const [position, setPosition] = useState<TWindowPosition>({ x: 0, y: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const windowRef = useRef<HTMLDivElement>(null);
  const [selectedId, setSelectedId] = useState<string>();
  const [selectedTitle, setSelectedTitle] = useState<string>();
  const [selectedRelCode, setSelectedRelCode] = useState<number>();

  const { openDocument } = useDocuments();

  const { isDragging, handleMouseDown } = useDraggable({
    initialPosition: position,
    containerRef,
    elementRef: windowRef,
    onPositionChange: (p) => setPosition(p),
    autoAlignToMiddle: true,
  });

  return (
    <div className="full-screen-modal" ref={containerRef}>
      <div
        className={`virtual-window advanced-search-container  ${isDragging ? "dragging" : ""} ${theme}`}
        ref={windowRef}
        style={{
          position: "absolute",
          top: `${position.y}px`,
          left: `${position.x}px`,
          height: '50vh',
        }}
      >
        <div className="window-header" onMouseDown={handleMouseDown}>
          <div className="window-title">
            <i className="file-icon">
              <Icons.BsLink />
            </i>
            <span>Relatii</span>
          </div>
          <div className="window-controls">
            <button className="window-control close" onClick={() => onClose()}>
              ✕
            </button>
          </div>
        </div>
        <div className="window-content">
          {
            loading
              ? <div className='lex-secondary-loading'>Se incarca ...</div>
              : <div className='advanced-search-panel-options-inner' style={{ minHeight: 300, width: '100%' }}>
                {
                  data.map((rel, idx) =>
                    <div
                      key={`${idx}-${rel.other_id}`}
                      className={`lex-doc-rel ${selectedId === rel.other_id && selectedRelCode === rel.rel_code ? 'selected' : ''}`}
                      onClick={() => {
                        setSelectedId(rel.other_id)
                        setSelectedRelCode(rel.rel_code)
                        setSelectedTitle(rel.other_doc.title)
                      }}
                      onDoubleClick={() => {
                        openDocument({ id: rel.other_id, title: rel.other_doc.title })
                        onClose();
                      }}
                    >
                      {rel.desc} {rel.other_doc.newtype} {rel.other_doc.issue_year}
                    </div>
                  )}
              </div>
          }
        </div>
        <div className="window-footer" style={{ justifyContent: 'center' }}>
          {/* <div className="advanced-search-button" style={{ opacity: 0 }}></div> */}
          <button
            className={`advanced-search-button ${selectedId === undefined ? 'disabled' : ''}`}
            style={{ marginRight: 'unset' }}
            onClick={() => {
              if (selectedId !== undefined && selectedTitle !== undefined) {
                openDocument({ id: selectedId, title: selectedTitle });
                onClose();
              }
            }}
          >
            Afiseaza
          </button>
          <button className="advanced-search-button" style={{ marginLeft: 'unset' }} onClick={onClose}>
            Inchide
          </button>
        </div>
      </div>
    </div>
  )
}

export default DocumentRelsModal;
